export default __webpack_public_path__ + "static/media/icon_verifications.01ea67f1.svg";